/* import __COLOCATED_TEMPLATE__ from './map.hbs'; */
/* RESPONSIBLE TEAM: team-standalone */

import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import type FinStandaloneService from 'embercom/services/fin-standalone-service';

interface Args {
  nextStep: () => void;
  previousStep: () => void;
}

export default class StandaloneSalesforceArticleSyncStepMap extends Component<Args> {
  @service declare finStandaloneService: FinStandaloneService;
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Standalone::Salesforce::Setup::ArticleSync::Steps::Map': typeof StandaloneSalesforceArticleSyncStepMap;
    'standalone/salesforce/setup/article-sync/steps/map': typeof StandaloneSalesforceArticleSyncStepMap;
  }
}
